export interface CompanyUserlyticsSettings {
    enabled: boolean;
    email: string;
    domain: string;
    teamId: string;
    projectId: string;
}

function isRecord(value: unknown): value is Record<string, unknown> {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}

function stringValue(value: unknown): string {
    return typeof value === 'string' ? value : '';
}

export function readCompanyUserlyticsSettings(
    customizations: Record<string, unknown>,
): CompanyUserlyticsSettings {
    const integrations = isRecord(customizations.integrations) ? customizations.integrations : {};
    return {
        enabled: integrations.userlytics === true,
        email: stringValue(integrations.userlyticsEmail),
        domain: stringValue(integrations.userlyticsDomain),
        teamId: stringValue(integrations.userlyticsTeamId),
        projectId: stringValue(integrations.userlyticsProjectId),
    };
}

export function mergeCompanyUserlyticsSettings(
    customizations: Record<string, unknown>,
    settings: CompanyUserlyticsSettings,
): Record<string, unknown> {
    const integrations = isRecord(customizations.integrations) ? customizations.integrations : {};
    return {
        ...customizations,
        integrations: {
            ...integrations,
            userlytics: settings.enabled,
            userlyticsEmail: settings.email,
            userlyticsDomain: settings.domain,
            userlyticsTeamId: settings.teamId,
            userlyticsProjectId: settings.projectId,
        },
    };
}
